module.exports = __webpack_public_path__ + "static/media/remove-circle.22badf58.svg";